import { render, staticRenderFns } from "./Assist.vue?vue&type=template&id=49191e94&scoped=true"
import script from "./Assist.vue?vue&type=script&lang=js"
export * from "./Assist.vue?vue&type=script&lang=js"
import style0 from "./Assist.vue?vue&type=style&index=0&id=49191e94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49191e94",
  null
  
)

export default component.exports